export const defaultValues = {
  mimeTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'application/pdf'],
  extensions: ['.png', '.jpg', '.jpeg', '.gif', '.pdf'],
  maxFileSize: 20 * 1024 * 1024, // 20MB
  noFilesMsg: 'No files selected',
  buttonText: 'Choose files',
  label: 'Attachments',
};
